import React from 'react';
import {DATAOPS_PROGRESS} from '../../config/constants';
import {ProgressIcon} from './ActionIcons/ActionIcons';
const Progress = ({status}: {status: string})=> {
  const progressStatus = DATAOPS_PROGRESS(status);

  const progressIcons = progressStatus.map((iconColor, index)=>{
    return <ProgressIcon color={iconColor} key={index}/>;
  });
  return(
    <label style={{display: 'flex', marginTop:'12px', justifyContent: 'center'}}>
      {progressIcons}
    </label>
  );
};

export default Progress;
